import { On3IconAthleteVerified } from '@on3/icons';
import { TextLink } from '@public/components/UI/Link/TextLink';

interface IAthleteVerifiedProps {
  className?: string;
}
export const AthleteVerified = ({ className }: IAthleteVerifiedProps) => {
  return (
    <TextLink className={className} href="/recruits/">
      <On3IconAthleteVerified />
      <span className="sr-only">Claim Profile</span>
    </TextLink>
  );
};
